import * as React from 'react';
import './bamburgh-theme/assets/base.scss';
import { BrowserRouter } from 'react-router-dom';
import Routes from "./Routes";
import NewVersionModal from './NewVersionModal'
import ProgressSpinner from '@/components/ProgressSpinner/ProgressSpinner';
import Dialog from '@/components/Dialog/Dialog';
import NotificationServiceWrapper from '@/components/NotificationServiceWrapper/NotificationServiceWrapper'
import ScrollUpButton from './components/ScrollUpButton/ScrollUpButton';
import { IoIosArrowUp } from 'react-icons/io';
import ErrorBoundary from '@/components/wrappers/ErrorBoundary/ErrorBoundary';
import { signalRUpdateConnectionStatus } from './store/SignalR';
import { useSignalRManualRefresh, useSignalRNegotiation } from 'prembid-shared-library-npm/signalr';
import { ConnectionStatus } from 'prembid-shared-library-npm/types';
import { useDispatch, useSelector } from 'react-redux';
import { AppThemeProvider } from './themes/AppTheme';


const ErrorFallback = ({ error, errorInfo }) => (
    <div>
        <h2>Something went wrong.</h2>
        <details style={{ whiteSpace: 'pre-wrap' }}>
            {error && error.toString()}
            <br />
            {errorInfo.componentStack}
        </details>
    </div>
);

export default () => {
    const dispatch = useDispatch();
    useSignalRNegotiation({
        onConnectionStatusChange: (connectionStatus) => dispatch(signalRUpdateConnectionStatus(connectionStatus)),
    });

    // The live connection can drop while the tab is in the background (browsers slow its checks there) and stops
    // retrying after a few minutes, so reconnect when the tab is shown again or the browser comes back online
    // (same as the client portal).
    const connectionStatus = useSelector((state: any) => state.signalR?.connectionStatus);
    const { restartConnection } = useSignalRManualRefresh();
    const reconnectState = React.useRef({ connectionStatus, restartConnection });
    reconnectState.current = { connectionStatus, restartConnection };
    React.useEffect(() => {
        const reconnectIfDown = () => {
            if (document.visibilityState !== "visible") return;
            const { connectionStatus: status, restartConnection: restart } = reconnectState.current;
            if (status === ConnectionStatus.Disconnected || status === ConnectionStatus.Error || status === ConnectionStatus.TimedOut) restart();
        };
        document.addEventListener("visibilitychange", reconnectIfDown);
        window.addEventListener("online", reconnectIfDown);
        return () => {
            document.removeEventListener("visibilitychange", reconnectIfDown);
            window.removeEventListener("online", reconnectIfDown);
        };
    }, []);

    return <AppThemeProvider>
    <BrowserRouter>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <React.StrictMode>
                {/* Back to top: the client portal's round white button with a chevron (styled in modern.css). */}
                <ScrollUpButton ShowAtPosition={600} StopPosition={0} ContainerClassName="pb-scrolltop" TransitionClassName="pb-scrolltop--on">
                    <IoIosArrowUp />
                </ScrollUpButton>
                <NotificationServiceWrapper />
                <ProgressSpinner />
                <Dialog />
                <Routes />
                <NewVersionModal />
            </React.StrictMode>
        </ErrorBoundary>
    </BrowserRouter>
    </AppThemeProvider>
};
